import { Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '@app/core';
import { AnimatedModalComponent } from '@app/shared/modals/animated-modal.component';

@Component({
  selector: 'app-guest-timed-modal',
  template: `
    <div (click)="reject()" class="icon close-popup"><i class="fal fa-times"></i></div>
    <form (ngSubmit)="submit()" [formGroup]="form" novalidate>
      <h5 translate>guest_timed_popup.headline</h5>
      <p translate>guest_timed_popup.sub_headline</p>

      <app-form-input type="email" formControlName="email" [title]="'default.email' | translate"></app-form-input>

      <div class="_10px-spacer"></div>
      <app-form-button class="full-width primary __ga__btn-guest-timed-email" type="submit">
        {{ 'guest_timed_popup.button' | translate }}
      </app-form-button>
      <div class="_10px-spacer"></div>
      <app-form-button
        class="small full-width __ga__btn-guest-timed-signup"
        [routerLink]="['/v2', { outlets: { modal: 'signup' } }]"
        (click)="reject()"
      >
        {{ 'guest_timed_popup.button_secondary' | translate }}
      </app-form-button>
    </form>
  `,
})
export class GuestModalTimedComponent extends AnimatedModalComponent {
  form: FormGroup;
  loading = false;
  errors = null;
  constructor(
    private ref: NgbActiveModal,
    private formBuilder: FormBuilder,
    private auth: AuthenticationService,
    protected elRef: ElementRef,
    protected renderer: Renderer2
  ) {
    super(elRef, renderer);
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  submit(): void {
    this.auth.guestTimed = true;
    if (!this.loading) {
      this.loading = true;
      this.auth.regEmail(this.form.get('email').value).subscribe(
        result => {
          this.loading = false;
          this.auth.guestEmail = this.form.get('email').value;
          this.close();
        },
        e => {
          this.loading = false;
          this.errors = 'Check your email and try again.';
        }
      );
    }
  }

  public close(): void {
    this.auth.guestTimed = true;
    this.auth.guestEmail = this.form.get('email').value;
    this.ref.close();
  }

  public reject(): void {
    this.auth.guestTimed = true;
    this.ref.dismiss();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/guest-modal-timed.component.ts